module.exports = {
  _pathPrefix: '/', // Prefix for all links. If you deploy your site to example.com/portfolio your pathPrefix should be "portfolio"
  _title: 'Better Books', // Navigation and Site Title
  _titleAlt: 'Better Books', // Title for JSONLD
  description: 'Some books are aweful, some are decent, others are better',
  _url: 'https://books.rambecks.com', // Domain of your site. No trailing slash!
  siteLanguage: 'en', // Language Tag on <html> element
  logo: '/logos/logo-1024.png', // Used for SEO

  // JSONLD / Manifest
  favicon: 'src/favicon.png', // Used for manifest favicon generation
  shortName: 'BetterBooks', // shortname for manifest. MUST be shorter than 12 characters
  author: 'Rambecks', // Author for schemaORGJSONLD
  themeColor: '#3D63AE',
  backgroundColor: '#EBEDF2',

  twitter: '@nrambeck', // Twitter Username
};
